import { render } from "./Password.vue?vue&type=template&id=bcfb03ba"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewdyster/NetBeansProjects/ezyzip-app/ezyzip-unzip/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__